import { render, staticRenderFns } from "./ContactAccessPrivileges.vue?vue&type=template&id=24e0782e&scoped=true"
import script from "./ContactAccessPrivileges.vue?vue&type=script&lang=js"
export * from "./ContactAccessPrivileges.vue?vue&type=script&lang=js"
import style0 from "./ContactAccessPrivileges.vue?vue&type=style&index=0&id=24e0782e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0782e",
  null
  
)

export default component.exports